import { render, staticRenderFns } from "./Discover.vue?vue&type=template&id=b4a8cb22&scoped=true"
import script from "./Discover.vue?vue&type=script&lang=js"
export * from "./Discover.vue?vue&type=script&lang=js"
import style0 from "./Discover.vue?vue&type=style&index=0&id=b4a8cb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a8cb22",
  null
  
)

export default component.exports